<div class="form-component">
    <div class="form-header">
        <h4 *ngIf="policyId === 0">Create client policy</h4>
        <h4 *ngIf="policyId > 0">Edit client policy</h4>
    </div>

    <form #form="ngForm" (ngSubmit)="createOrUpdatePolicy(form)">
        <!-- Policy Name -->
        <div class="input-group">
            <label for="areaName">Policy Name:<span class="required"> * </span></label>
            <div>
                <input
                    type="text"
                    id="areaName"
                    name="areaName"
                    #areaName="ngModel"
                    placeholder="Policy Name"
                    [class.invalid]="areaName.invalid"
                    [(ngModel)]="policy.areaName"
                    required />
                <div *ngIf="areaName.invalid">
                    <span class="error">Policy name is required</span>
                </div>
            </div>
        </div>

        <!-- Policy Number -->
        <div class="input-group">
            <label for="policyNumber">Policy Number:<span class="required"> * </span></label>
            <div>
                <input
                    type="text"
                    id="policyNumber"
                    name="policyNumber"
                    #policyNumber="ngModel"
                    placeholder="Policy Number"
                    [class.invalid]="policyNumber.invalid"
                    [(ngModel)]="policy.policyNumber"
                    required />
                <div *ngIf="policyNumber.invalid">
                    <span class="error">Policy number is required</span>
                </div>
            </div>
        </div>

        <!-- Inception Date -->
        <div class="input-group">
            <label for="inceptionDate">Inception Date:<span class="required">*</span></label>
            <div>
                <input
                    type="date"
                    id="inceptionDate"
                    name="inceptionDate"
                    #inceptionDate="ngModel"
                    [class.invalid]="inceptionDate.invalid"
                    [(ngModel)]="policy.inceptionDate"
                    required />
                <div *ngIf="inceptionDate.invalid">
                    <span class="error">Inception date is required</span>
                </div>
            </div>
        </div>

        <!-- Insurer -->
        <div class="input-group">
            <auto-complete-dropdown
                [options]="insurers"
                [label]="'Insurer:'"
                [placeholder]="'Select an insurer...'"
                [initialValue]="policy.insurerId"
                [required]="true"
                [invalid]="!policy.insurerId && formSubmitted"
                [validationMessage]="'Insurer is required'"
                [displayWith]="displayInsurer"
                (selectionChange)="onInsurerSelectionChange($event)">
            </auto-complete-dropdown>
        </div>

        <!-- Policy Base -->
        <div class="input-group">
            <auto-complete-dropdown
                [options]="policyBaseOptions"
                [label]="'Policy Base:'"
                [placeholder]="'Select an policy base...'"
                [initialValue]="selectedPolicyBaseId"
                [required]="true"
                [invalid]="!selectedPolicyBaseId && formSubmitted"
                [validationMessage]="'Policy base is required'"
                [displayWith]="displayPolicyBase"
                (selectionChange)="onPolicyBaseSelectionChange($event)">
            </auto-complete-dropdown>
        </div>

        <!-- Industry -->
        <div class="input-group">
            <auto-complete-dropdown
                [options]="industries"
                [label]="'Industry:'"
                [placeholder]="'Select an industry...'"
                [initialValue]="selectedIndustryId"
                [required]="false"
                [validationMessage]="'Industry is required'"
                [displayWith]="displayIndustry"
                (selectionChange)="onIndustrySelectionChange($event)">
            </auto-complete-dropdown>
        </div>

        <!-- Policy -->
        <div class="input-group">
            <auto-complete-dropdown
                [options]="policyGroups"
                [label]="'Policy Group:'"
                [placeholder]="'Select a policy group...'"
                [initialValue]="selectedPolicyGroupId"
                [required]="false"
                [validationMessage]="'Policy group is required'"
                [displayWith]="displayPolicyGroup"
                (selectionChange)="onPolicyGroupSelectionChange($event)">
            </auto-complete-dropdown>
        </div>

        <!-- Ageing Includes VAT -->
        <div class="input-group">
            <label for="ageingIncludesVat">Ageing Includes VAT:</label>
            <switch-control
                name="ageingIncludesVat"
                [(ngModel)]="policy.ageingIncludesVat"
                label="Ageing Includes VAT:">
            </switch-control>
        </div>

        <!-- Sales Includes VAT -->
        <div class="input-group">
            <label for="salesIncludesVat">Sales Includes VAT:</label>
            <switch-control
                name="salesIncludesVat"
                [(ngModel)]="policy.salesIncludesVat"
                label="Sales Includes VAT:">
            </switch-control>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button
                type="submit"
                class="button-save"
                [disabled]="form.invalid || isSaving">
                <span *ngIf="isSaving" class="loading-spinner"></span>
                <i *ngIf="!isSaving" class="fas fa-save"></i>
                Save
            </button>
            <button (click)="addAnotherPolicy()">
                <i class="fas fa-plus"></i> Add Another Policy
            </button>
            <button
                type="button"
                class="button-cancel"
                (click)="onClear()">
                <i class="fas fa-cancel"></i> Clear
            </button>
        </div>
    </form>
</div>
